export default __webpack_public_path__ + "static/media/dragToExplore.48c8dbd0.gif";